import { Wrench, CheckCircle2 } from "lucide-react";
import { careers } from "@/data/siteConfig";
import { Seo } from "@/components/Seo";
import { PageHero } from "@/components/PageHero";
import { CallButton } from "@/components/CallButton";
import { ContactCTA } from "@/components/home/ContactCTA";
import { Reveal } from "@/components/Reveal";

const points = [
  "Real, hands-on experience with locks and safes",
  "Learn from difficult, specialized jobs",
  "Direct mentorship from Jose Velasco",
  "A trade with genuine, lasting skills",
];

export default function Careers() {
  return (
    <>
      <Seo
        title="Careers — Learn the Locksmith & Safe Trade"
        description="Interested in locksmith and safe work? Velasco Lock and Safe would like to hear from motivated people who want to learn the trade. Call or send a message to connect."
        path="/careers"
      />
      <PageHero
        overline="Careers · Learn the Trade"
        title={careers.headline}
        description={careers.body}
        showCall={false}
      />

      <section className="bg-ink py-20 md:py-28">
        <div className="mx-auto max-w-[1440px] px-5 md:px-8">
          <div className="grid gap-12 lg:grid-cols-2 lg:gap-16">
            <Reveal>
              <div className="border border-white/10 bg-ink-surface p-8 md:p-10">
                <div className="mb-6 flex items-center gap-2 font-heading text-xs font-bold uppercase tracking-[0.2em] text-gold">
                  <Wrench className="h-4 w-4" /> What you'll find
                </div>
                <ul className="space-y-4">
                  {points.map((p) => (
                    <li key={p} className="flex gap-3 leading-relaxed text-steel-light">
                      <CheckCircle2 className="mt-0.5 h-5 w-5 shrink-0 text-gold" />
                      {p}
                    </li>
                  ))}
                </ul>
                <p className="mt-8 text-sm leading-relaxed text-steel/70">{careers.note}</p>
              </div>
            </Reveal>

            <div className="flex flex-col justify-center">
              <h2 className="font-heading text-3xl font-extrabold tracking-tight text-white sm:text-4xl">
                Curious about the trade? Let's talk.
              </h2>
              <p className="mt-5 text-lg leading-relaxed text-steel">
                The best way to start is a conversation. Call or send a message and tell us
                about yourself and why the work interests you.
              </p>
              <div className="mt-8">
                <CallButton size="lg" showNumber testid="careers-page-call-btn" />
              </div>
            </div>
          </div>
        </div>
      </section>

      <ContactCTA />
    </>
  );
}
